import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Simple mobile sticky CTA to book a discovery call.
// Hides on the positioning-review page itself.
export default function MobileStickyBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/positioning-review")) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      style={{ backgroundColor: "#0a0a0a" }}
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl border-t border-zinc-800 dark-section"
    >
      <Link
        to="/positioning-review"
        data-testid="mobile-sticky-discovery"
        className="w-full flex items-center justify-between px-5 py-3.5"
      >
        <span className="text-left">
          <span
            className="block label-eyebrow"
            style={{ color: "#94a3b8" }}
          >
            Ready to start?
          </span>
          <span
            className="block font-heading font-bold text-sm mt-0.5"
            style={{ color: "#ffffff" }}
          >
            Book A Discovery Call
          </span>
        </span>
        <span
          className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-widest px-3 py-2 rounded-md"
          style={{ backgroundColor: "#06b6d4", color: "#ffffff" }}
        >
          Go <ArrowUpRight className="h-3.5 w-3.5" />
        </span>
      </Link>
    </div>
  );
}
